import classNames from 'classnames';
import * as React from 'react';
const Title = ({ prefixCls, className, width, style }) => (<h3 className={classNames(prefixCls, className)} style={Object.assign({ width }, style)}/>);
export default Title;
